import { Slide, SlideMedia, TextAlignment } from '@/client/courses';
import { ContentMediaItem } from '@/ui/content-media';
import React from 'react';
import styled from 'styled-components';

const SlideImageComponentContainer = styled.div<{
  isGallery?: boolean;
  isSummary?: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ isGallery }) => (isGallery ? '100%' : '375px')};
  min-width: 0;
  height: 100%;

  && h3,
  && p {
    color: ${({ isSummary }) =>
      isSummary ? 'var(--white-main)' : 'var(--black-main)'};
  }
`;

type SlideImageComponentProps = {
  image: SlideMedia;
  currentEditingSlide?: Slide;
  updateSlide?: (id: string, updates: Partial<Slide>) => void;
  textAlignment?: TextAlignment;
  isGallery?: boolean;
  isSummary?: boolean;
};

export const SlideImageComponent: React.FC<SlideImageComponentProps> = ({
  image,
  currentEditingSlide,
  updateSlide,
  textAlignment = TextAlignment.LEFT,
  isGallery = false,
  isSummary = false,
}) => {
  const slideId = currentEditingSlide?.id;

  return (
    <SlideImageComponentContainer isGallery={isGallery} isSummary={isSummary}>
      <ContentMediaItem
        media={image}
        textAlignment={textAlignment}
        mediaHeight={isGallery ? '220px' : undefined}
        onChange={
          updateSlide && slideId
            ? (media) =>
                updateSlide(slideId, {
                  images: currentEditingSlide?.images?.map((img) =>
                    img.position === media.position ? media : img,
                  ),
                })
            : undefined
        }
      />
    </SlideImageComponentContainer>
  );
};
